import { Directive } from '@angular/core';
import { AbstractControl, AsyncValidator, AsyncValidatorFn, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { CompaniesClient, CompanySearchViewModel, FilterBy } from '@services/cleanfill-api/cleanfill-api.generated';
import { Observable, of, timer } from 'rxjs';
import { map, switchMapTo } from 'rxjs/operators';

@Directive({
  selector: '[duplicateCompanyNameValidator][ngModel],[duplicateCompanyNameValidator][FormControl]',
  providers: [{ provide: NG_ASYNC_VALIDATORS, useExisting: DuplicateCompanyNameValidator, multi: true }]
})
export class DuplicateCompanyNameValidator implements AsyncValidator {
  companyId: string;
  constructor(private companiesClient: CompaniesClient) {}

  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    // turn into an observable
    return of(this._validateInternal(control));
  }
  getAsyncValidator(companyId: string): AsyncValidatorFn {
    this.companyId = companyId;
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      return timer(500).pipe(
        switchMapTo(this._findMatchesByName(control.value)),
        map((t: CompanySearchViewModel[]) => this._mapToValidationFlag(t))
      );
    };
  }

  _validateInternal(control: AbstractControl): Observable<ValidationErrors> | null {
    const name = control.value;
    const matching = this._findMatchesByName(name);
    return matching.pipe(map(t => this._mapToValidationFlag(t)));
  }

  _mapToValidationFlag(t: CompanySearchViewModel[]) {
    if (t.length > 0 && !t.find(company => company.uniqueId === this.companyId)) {
      return {
        duplicateCompanyName: {
          name: t[0].name
        }
      };
    }
    return null;
  }

  _findMatchesByName(name: string) {
    const filterBy = new FilterBy();
    filterBy.property = 'name';
    filterBy.equal = name;
    return this.companiesClient.searchCompany(1, 1, [], [filterBy], undefined);
    // .pipe(map((company => records?.filter(company => company.name.toLowerCase() === name.toLowerCase()) || []));
  }
}
